jQuery("filtered-posts article:first-child").attr("id", "featured");

// Hero button and anchor link scrolling
jQuery(function () {
  // Select second section from main div and add id with name page-content
  var first_content = jQuery("main section:nth-child(2)");
  if (!first_content.attr("id")) first_content.attr("id", "page-content");

  jQuery(".hero-button a.scroll-button").attr(
    "href",
    "#" + first_content.attr("id")
  );

  jQuery('a[href*="#"]:not([href="#"])').click(function () {
    if (
      location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
      location.hostname == this.hostname
    ) {
      var target = jQuery(this.hash);
      target = target.length
        ? target
        : jQuery("[href=" + this.hash.slice(1) + "]");
      if (target.length) {
        jQuery("html, body").animate(
          {
            scrollTop: target.offset().top - 110,
          },
          500
        );
        return false;
      }
    }
  });
});

// Siirtää scrollia headerin korkeuden verran, jos sivulle tullaan ankkurilinkillä
(function ($, window) {
  var adjustAnchor = function () {
    var $anchor = $(":target"),
      headerHeight = 100;

    if ($anchor.length > 0) {
      $("html, body")
        .stop()
        .animate(
          {
            scrollTop: $anchor.offset().top - headerHeight,
          },
          200
        );
    }
  };

  $(window).on("hashchange load", function () {
    adjustAnchor();
  });
})(jQuery, window);
